export default __webpack_public_path__ + "static/media/adventour-booking.63f3fead.JPG";